import IndexAdjustmentReviewCard from './IndexAdjustmentReviewCard';

export const briefingComponentRegistry = {
  IndexAdjustmentReviewCard: {
    capabilityId: 'rent.index_adjustment.review',
    component: IndexAdjustmentReviewCard,
    allowedActions: [
      'open_calculation',
      'preview_letter',
      'create_mail_draft',
    ],
  },
};
